<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.addChildrenMenu" size="mini" status="primary" @click="addChildrenMenu"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
      <vxe-button content="button.delete" size="mini" status="danger" @click="del"/>
    </a-space>
    <a-spin :spinning="spinning">
      <a-row type="flex">
        <a-col :span="6">
          <a-divider style="margin-top: 2px">{{$t('business.label.menu')}}</a-divider>
          <div class="leftMenu">
            <menu-tree ref="menuTree" @getDetailData="getDetailData" @loading="loading" @sendSelectedKey="sendSelectedKey" @sendSelectedParentKey="sendSelectedParentKey"></menu-tree>
          </div>
        </a-col>
        <a-col :span="15">
          <a-divider style="margin-top: 2px">{{$t('business.label.menuDetail')}}</a-divider>
          <menu-detail ref="menuDetail" @deleteSave="deleteSave"></menu-detail>
        </a-col>
      </a-row>
    </a-spin>
  </a-layout>
</template>
<script>
import { deleteOne } from '@/api/Api'
import ARow from 'ant-design-vue/es/grid/Row'
import ACol from 'ant-design-vue/es/grid/Col'
import MenuTree from '@/views/config/menu/MenuTree.vue'
import MenuDetail from '@/views/config/menu/MenuDetail.vue'

export default {
  name: 'MenuMaintenance',
  components: { MenuDetail, MenuTree, ACol, ARow },
  data() {
    return {
      treeData: [],
      treeList: [],
      selectedKeys: [],
      spinning: false
    }
  },
  mounted() {
    this.$refs.menuTree.getData()
  },
  methods: {
    getDetailData(id) {
      this.$refs.menuDetail.getData(id)
    },
    //增加子菜单
    addChildrenMenu() {
      this.$refs.menuTree.getSelectedKey()
    },
    sendSelectedKey(selectedKey) {
      this.$refs.menuDetail.addChildMenu(selectedKey)
    },
    //增加同级菜单
    addMenu() {
      this.$refs.menuTree.getSelectedParentKey()
    },
    sendSelectedParentKey(selectedParentKey) {
      this.$refs.menuDetail.addMenu(selectedParentKey)
    },
    refresh() {
      this.$refs.menuTree.refresh()
      this.$refs.menuDetail.refresh()
    },
    save() {
      this.$sign({
        reason: '菜单维护保存',
        button: 'save',
        router: this.$route,
        click: () => {
          this.$refs.menuDetail.save()
        }
      })
    },
    saveSuccess(response) {
      this.$refs.menuDetail.getData(response.id)
    },
    del() {
      let that = this
      this.$confirm({
        title: that.$t('message.deleteMenu'),
        content: that.$t('message.deleteMenuTip'),
        onOk() {
          that.$refs.menuDetail.delete()
        },
        onCancel() {
        },
        centered: true
      })
    },
    deleteSave(id) {
      deleteOne('menuDeleter', { id: id }).then(res => {
        if (res.success) {
          this.refresh()
          this.$message.success(this.$t('message.deleteSuccess'))
        }
      })
    },
    loading(loading) {
      this.spinning = loading
    }
  }
}
</script>
<style scoped lang="css">
/deep/ .leftMenu {
  overflow-y: scroll;
  height: 70vh;
}

/deep/ .leftMenu::-webkit-scrollbar {
  width: 4px; /*  设置纵轴（y轴）轴滚动条 */
  height: 4px; /*  设置横轴（x轴）轴滚动条 */
}

/* 滚动条滑块（里面小方块） */
/deep/ .leftMenu::-webkit-scrollbar-thumb {
  border-radius: 0;
  background: transparent;
}

/* 滚动条轨道 */
/deep/ .leftMenu::-webkit-scrollbar-track {
  border-radius: 0;
  background: transparent;
}

/* hover时显色 */
/deep/ .leftMenu:hover::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

/deep/ .leftMenu:hover::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

</style>